<template>
<div class="">
<b-navbar toggleable="md" class="nav-bar-header">
  <b-navbar-brand>
     <img :src='"../../assets/img/logo.png"' class="img-nav">
  </b-navbar-brand>
  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  <b-collapse is-nav id="nav_collapse" class="text-right">
    <b-navbar-nav  class="ml-auto mr-4">
      <b-nav-item v-scroll-to="'#aliatica'" class="home txt-prim"><b>TRANSPARENCIA</b></b-nav-item>
      <b-nav-item v-scroll-to="'#viaducto'" class="viaducto"><b>VIADUCTO BICENTENARIO</b></b-nav-item>
      <b-nav-item v-scroll-to="'#circuito'" class="circuito"><b>CIRCUITO EXTERIOR MEXIQUENSE</b></b-nav-item>
    </b-navbar-nav>
  </b-collapse>
</b-navbar>

</div>
</template>
<script>
export default {
  name: 'header',
  data(){
    return{
      active: 'home'
    }
  },
  methods: {
    makeActive: function(item){
      this.active = item
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/header.vue